import { axios as service, axios as apiService } from '../axiosService';
import { BASE_URL } from './index';

export const getNavigatorTemplateRequest = (type) =>
  apiService.get(`${BASE_URL}/project/integrationNavTemplate?type=${type}`);

export const updateNavigatorTemplateRequest = (params = {}) =>
  apiService.post(
    `${BASE_URL}/project/integrationNavTemplate?type=${params.type}`,
    params,
  );

export const getValuedriverTemplateRequest = (instanceId) =>
  apiService.get(`${BASE_URL}/project/valueDriverTemplate/${instanceId}`);

export const updateValuedriverTemplateRequest = (params) =>
  apiService.post(
    `${BASE_URL}/project/valueDriverTemplate/${params.instanceId}`,
    params,
  );

export const getGuidingPrincipleTemplateRequest = (companyInstance) =>
  apiService.get(
    `${BASE_URL}/project/guidingPrincipleTemplate?type=${companyInstance}`,
  );

export const updateGuidingPrincipleTemplateRequest = (
  params,
  companyInstance,
) =>
  apiService.post(
    `${BASE_URL}/project/guidingPrincipleTemplate${
      companyInstance ? `?type=${companyInstance}` : ''
    }`,
    params,
  );

export const getUserGuideRequest = (type) =>
  apiService.get(`${BASE_URL}/project/userGuide/pdf?pdfType=${type}`, {
    responseType: 'blob',
  });

export const uploadUserGuideRequest = (projectId, data, type) => {
  const url = `${BASE_URL}/project/userGuide/pdf?pdfType=${type}`;
  return service.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
  });
};

export const getPowerBiGuideRequest = () =>
  apiService.get(
    `${BASE_URL}/project/userGuide/getPDFByType?pdfType=Integration Hub User Guide`,
    {
      responseType: 'blob',
    },
  );

export const getSystemModuleTemplate = (type) =>
  apiService.get(`${BASE_URL}/project/customizeModuleTemplate?type=${type}`);

export const saveSystemModuleTemplate = (type, params) =>
  apiService.post(
    `${BASE_URL}/project/customizeModuleTemplate?type=${type}`,
    params,
  );

export const getSystemSpnId = () =>
  apiService.get(
    `${BASE_URL}/project/customizeModuleTemplate/getSystemSpnConfig`,
  );

export const getAllProjectInstances = () =>
  apiService.get(`${BASE_URL}/project/projectInstance`).catch((e) => []);

export const getTemplateById = (id, type) =>
  apiService
    .get(`${BASE_URL}/project/projectTemplate`, {
      params: { id, type },
    })
    .catch(() => []);

export const saveSystemTemplate = (params) =>
  apiService.post(`${BASE_URL}/project/projectTemplate`, params);

export const deleteSystemTemplate = (templateId) =>
  apiService.delete(`${BASE_URL}/project/deleteProjectInstance/${templateId}`);

export const getDefaultTemplate = () =>
  apiService
    .get(`${BASE_URL}/project/getCustomzeDeafultProjectTemplate`)
    .catch(() => []);
